import {Injectable} from '@angular/core';
import {ModuleInterface} from '../shared/ModuleInterface';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {LoaderService} from './loader.service';
import {Observable} from 'rxjs';
import {AuthService} from './auth.service';
import {A0} from '../shared/entities/A0.entity';

@Injectable()
export class IgoService  {

  public module: ModuleInterface;
  public headers: HttpHeaders;

  constructor(
    public httpClient: HttpClient,
    public loaderService: LoaderService,
    public authService: AuthService
  ) {
    this.module = new ModuleInterface('mapper', this.httpClient, this.loaderService, true);
    this.module.addAuthorizationInAllRequest();
  }

  getPcs(plan: A0): Observable<any> {
    const typeRisque = this.getIgoPlanId(plan.type_risque);

    return this.module.get(`pcs/${plan.type_zone}/${plan.code_zone}/${typeRisque}`);
  }

  // TODO : A supprimer quand endpoint dispo dans le backend
  getIgoPlanId(alias: string): number {
    const list = [{"id":4,"alias":"inondation","nom":"Inondation","id_igo":1},{"id":6,"alias":"submersion","nom":"Submersion","id_igo":2},{"id":3,"alias":"neige","nom":"Neige","id_igo":3},{"id":2,"alias":"tempete","nom":"Tempête","id_igo":4},{"id":28,"alias":"feu","nom":"Feu","id_igo":8},{"id":14,"alias":"industriel","nom":"Industriel","id_igo":14},{"id":13,"alias":"tmd","nom":"Transport de matières dangereuses","id_igo":13},{"id":104,"alias":"cyclone","nom":"Cyclone","id_igo":12},{"id":9,"alias":"mvt","nom":"Mouvement de terrain","id_igo":9}]

    return list.find(i => i.alias === alias).id_igo;
  }
}
